import Vue from "vue";
import WidgetBreadcrumbNav from "../cpWidget/WidgetBreadcrumbNav.vue";
import WidgetToastScreen from "./WidgetToastScreen.vue";
Vue.component("widget-breadcrumb-nav", WidgetBreadcrumbNav);
Vue.component("widget-toast-screen", WidgetToastScreen);
